import { Link } from "@mui/material";
import { isInteger, sum } from "lodash-es";
import Fab from "@mui/material/Fab";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import ShoppingCartTwoToneIcon from "@mui/icons-material/ShoppingCartTwoTone";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const FloatingCart = ({
	formID,
	minCartItemCount,
	maxCartItemCount,
	cartItems = [],
}) => {
	const intl = useIntl();
	const REACT_APP_WEB_URL = process.env.REACT_APP_WEB_URL;
	const totalQuantity = sum(
		Object.values(cartItems ?? []).map((item) => item.quantity)
	);
	const minQuantity = minCartItemCount ?? 0;
	const maxQuantity = maxCartItemCount ?? Infinity;
	const notWithinRange = Boolean(
		isInteger(totalQuantity) &&
			(totalQuantity < minQuantity || totalQuantity > maxQuantity)
	);
	const [filteredCart, setFilteredCart] = useState("");

	useEffect(() => {
		const newCart = cartItems.map((item) => ({
			id: item.id,
			amount: item.quantity,
		}));

		if (cartItems.length > 0) {
			const jsonString = JSON.stringify(newCart);
			const base64String = btoa(jsonString);
			setFilteredCart(base64String);
		}
	}, [cartItems]);

	if (!totalQuantity) return <></>;

	if (notWithinRange) return <></>;

	return (
		totalQuantity && (
			<Fab
				component={Link}
				href={
					totalQuantity > 0
						? `${REACT_APP_WEB_URL}/events/register/${formID}?cart=${filteredCart}`
						: null
				}
				target="_blank"
				rel="noopener noreferrer"
				size="large"
				sx={{
					top: "50%",
					position: "fixed",
					right: 0,
					zIndex: 1200,
					bgcolor: "#333",
					color: "warning.light",
					borderRadius: "var(--btn-radius, 10px)",
					borderTopRightRadius: 0,
					borderBottomRightRadius: 0,
					"&:hover .cartIcon": { color: "#333333" },
				}}
			>
				<IconButton
					disableRipple
					aria-label={`${intl.formatMessage({ id: "cart" })} (${totalQuantity})`}
					size="large"
				>
					<Badge
						showZero
						badgeContent={totalQuantity}
						color="error"
						sx={{
							"& .MuiBadge-badge": {
								right: 0,
								top: 3,
								border: "2px solid",
								borderColor: "background.paper",
								px: 0.5,
							},
						}}
					>
						<ShoppingCartTwoToneIcon
							className="cartIcon"
							sx={{
								color: "#ffffff",
							}}
						/>
					</Badge>
				</IconButton>
			</Fab>
		)
	);
};

export default FloatingCart;
